import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProductBanner from './components/ProductBanner';
import CategorySidebar from './components/CategorySidebar';
import ProductGrid from './components/ProductGrid';

export default function ProductPage() {
  const [selectedCat, setSelectedCat] = useState('all');
  const [selectedSub, setSelectedSub] = useState('all');

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <ProductBanner />

        <section className="max-w-6xl mx-auto px-4 py-12">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <CategorySidebar
              selectedCat={selectedCat}
              selectedSub={selectedSub}
              onSelectCat={setSelectedCat}
              onSelectSub={setSelectedSub}
            />
            <ProductGrid
              selectedCat={selectedCat}
              selectedSub={selectedSub}
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
